import React from "react";
import { useHistory } from "react-router-dom";
import { CheckCircle as CheckCircleIcon } from "@material-ui/icons";
import { Paper } from "@material-ui/core";

import Button from "../../components/Button";
import { useStyles } from "./styles";

export const PaymentSuccess = () => {
  const classes = useStyles();
  const history = useHistory();

  const handleBackToProfile = () => {
    history.push("/pilot/profile");
  };

  return (
    <div className={classes.container}>
      <Paper className={classes.content}>
        <CheckCircleIcon className={classes.icon} />
        <div className={classes.title}>Payment Successful!</div>
        <div className={classes.message}>
          Thank you for your purchase. Your transaction has been processed successfully.
          Your account has been updated.
        </div>
        <Button
          text="Back to Profile"
          onClick={handleBackToProfile}
          classes={classes.button}
        />
      </Paper>
    </div>
  );
};

export default PaymentSuccess;
